export enum StorageKeys {
  Register = 'con_register',
  Payment = 'payment',
  Speciality = 'speciality',
  Hotel = 'hotel',
}
